<script setup lang="ts">
import { useI18n } from '@/i18n'

const { t } = useI18n()
</script>

<template>
  <div class="legal-view">
    <div class="legal-container">
      <h1>{{ t('privacy.title') }}</h1>
      <p class="last-update">{{ t('privacy.last_update') }}: 15/01/2026</p>
      
      <section>
        <h2>1. {{ t('privacy.intro.title') }}</h2>
        <p>{{ t('privacy.intro.content') }}</p>
      </section>
      
      <section>
        <h2>2. {{ t('privacy.collected.title') }}</h2>
        <p>{{ t('privacy.collected.content') }}</p>
        <ul>
          <li>{{ t('privacy.collected.item1') }}</li>
          <li>{{ t('privacy.collected.item2') }}</li>
          <li>{{ t('privacy.collected.item3') }}</li>
          <li>{{ t('privacy.collected.item4') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>3. {{ t('privacy.usage.title') }}</h2>
        <p>{{ t('privacy.usage.content') }}</p>
        <ul>
          <li>{{ t('privacy.usage.item1') }}</li>
          <li>{{ t('privacy.usage.item2') }}</li>
          <li>{{ t('privacy.usage.item3') }}</li>
          <li>{{ t('privacy.usage.item4') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>4. {{ t('privacy.storage.title') }}</h2>
        <p>{{ t('privacy.storage.content') }}</p>
      </section>
      
      <section>
        <h2>5. {{ t('privacy.sharing.title') }}</h2>
        <p>{{ t('privacy.sharing.content') }}</p>
        <ul>
          <li>{{ t('privacy.sharing.item1') }}</li>
          <li>{{ t('privacy.sharing.item2') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>6. {{ t('privacy.cookies.title') }}</h2>
        <p>{{ t('privacy.cookies.content') }}</p>
      </section>
      
      <section>
        <h2>7. {{ t('privacy.rights.title') }}</h2>
        <p>{{ t('privacy.rights.content') }}</p>
        <ul>
          <li>{{ t('privacy.rights.item1') }}</li>
          <li>{{ t('privacy.rights.item2') }}</li>
          <li>{{ t('privacy.rights.item3') }}</li>
          <li>{{ t('privacy.rights.item4') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>8. {{ t('privacy.security.title') }}</h2>
        <p>{{ t('privacy.security.content') }}</p>
      </section>
      
      <section>
        <h2>9. {{ t('privacy.contact.title') }}</h2>
        <p>{{ t('privacy.contact.content') }}</p>
        <p class="contact-email">📧 privacy@m2v.io</p>
      </section>
    </div>
  </div>
</template>

<style scoped>
.legal-view {
  min-height: calc(100vh - 64px);
  padding: var(--m2v-space-12) var(--m2v-space-6);
}

.legal-container {
  max-width: 800px;
  margin: 0 auto;
}

h1 {
  font-family: var(--m2v-font-display);
  font-size: 2.5rem;
  margin-bottom: var(--m2v-space-2);
}

.last-update {
  color: var(--m2v-text-muted);
  font-size: 0.875rem;
  margin-bottom: var(--m2v-space-10);
}

section {
  margin-bottom: var(--m2v-space-8);
}

h2 {
  font-size: 1.25rem;
  margin-bottom: var(--m2v-space-4);
  color: var(--m2v-text-primary);
}

p {
  color: var(--m2v-text-secondary);
  line-height: 1.7;
  margin-bottom: var(--m2v-space-4);
}

ul {
  list-style: disc;
  padding-left: var(--m2v-space-6);
  color: var(--m2v-text-secondary);
  margin-bottom: var(--m2v-space-4);
}

li {
  line-height: 1.7;
  margin-bottom: var(--m2v-space-2);
}

.contact-email {
  color: var(--m2v-primary-light);
  font-weight: 500;
}
</style>
